import React from 'react';

const SustainableFuelsText = () => {
  return (
    <div
      style={{
        fontSize: '22px',
        fontWeight: '400',
        lineHeight: '36.57px',
        
        fontFamily: 'Times New Roman, Times, serif',
        color: "#555555"
      }}>

      <p style={{ marginBottom: '10px', fontSize: 22 }}>
        <strong>EU Adopts New Law to Decarbonize Aviation Sector with Sustainable Fuels</strong>
      </p>

      <p style={{ marginBottom: '20px' }}>
        The European Union has taken a major step towards decarbonizing the
        aviation sector with the adoption of a new regulation on the "RefuelEU
        Aviation" initiative. This initiative aims to increase the use of
        sustainable aviation fuels (SAF) and synthetic fuels, which have lower
        CO2 emissions than fossil fuels, in order to reduce the environmental
        impact of air travel.
      </p>
      <h2 style={{ marginBottom: '20px' }}>Key points</h2>
      <ul
        style={{
          marginBottom: '20px',
          listStyleType: 'disc',
          paddingLeft: '20px',
        }}>
        <li style={{ marginBottom: '10px' }}>
          Objectives of the new legislations
        </li>
        <li style={{ marginBottom: '10px' }}>
          Provisions of the new regulation
        </li>
        <li style={{ marginBottom: '10px' }}>Impact of the new regulation</li>
      </ul>
      <h2 style={{ marginBottom: '20px' }}>
        Main Objectives of the New Legislation
      </h2>
      <ul
        style={{
          marginBottom: '20px',
          listStyleType: 'disc',
          paddingLeft: '20px',
        }}>
        <li style={{ marginBottom: '10px' }}>
          Increase demand for and supply of SAF and synthetic fuels.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Put air transport on track to meet the EU's climate targets for 2030
          and 2050.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Address the current challenges of low supply and high prices of SAF.
        </li>
      </ul>
      <h2 style={{ marginBottom: '20px' }}>
        Main Provisions of the New Regulation
      </h2>
      <ul
        style={{
          marginBottom: '20px',
          listStyleType: 'disc',
          paddingLeft: '20px',
        }}>
        <li style={{ marginBottom: '10px' }}>
          Obligation for aviation fuel suppliers to ensure that a minimum share
          of the fuel made available to aircraft operators at EU airports is SAF
          or synthetic fuel, with the share increasing progressively until 2050.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Obligation for aircraft operators to ensure that they uplift at least
          90% of their annual aviation fuel requirement at EU airports, to avoid
          "tankering" practices that would lead to additional emissions.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Definition of eligible SAF and synthetic fuels, including certified
          biofuels, renewable fuels of non-biological origin (such as renewable
          hydrogen), and recycled carbon aviation fuels.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Establishment of rules for competent authorities to enforce the
          regulation and for fines.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Creation of a Union labeling scheme about environmental performance
          for aircraft operators using SAF, to help consumers make informed
          choices and promote greener flights.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Data collection and reporting obligations for fuel suppliers and
          aircraft operators to monitor the effects of the regulation.
        </li>
      </ul>
      <h2 style={{ marginBottom: '20px' }}>Impact of the New Regulation</h2>
      <ul
        style={{
          marginBottom: '20px',
          listStyleType: 'disc',
          paddingLeft: '20px',
        }}>
        <li style={{ marginBottom: '10px' }}>
          Reducing the CO2 emissions from air travel.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Stimulating the development and production of SAF and synthetic fuels.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Creating a level playing field for airlines that use sustainable
          fuels.
        </li>
        <li style={{ marginBottom: '10px' }}>
          Helping the EU to meet its climate targets.
        </li>
      </ul>
      <h2 style={{ marginBottom: '20px' }}>Additional Information</h2>
      <p style={{ marginBottom: '10px' }}>
        The new regulation is part of the EU's Fit for 55 package, which aims to
        reduce the EU's net greenhouse gas emissions by at least 55% by 2030
        compared to 1990 levels.
      </p>
      <p style={{ marginBottom: '10px' }}>
        The regulation was adopted by the Council of the European Union on
        October 9, 2023.
      </p>
      <p style={{ marginBottom: '10px' }}>
        The regulation will enter into force 20 days after its publication in
        the Official Journal of the European Union.
      </p>
    </div>
  );
};

export default SustainableFuelsText;
